<div id="view_request_dialog">
    <div class="position_relative" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100 dialog_header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div class="header" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                <div>NEW CLEANING REQUEST!</div>
                <div class="header_room">Room No. {{roomNumber}}</div>
            </div>
            <div class="filter_section dropdownCustom" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                <app-select class="filter_3" label="Status" [noEmptyValue]="true" [value]="requestStatus"
                    (selectionChange)="requestStatus = $event" [selectOptions]="selectOptions"></app-select>
            </div>
        </div>
        <div class="width_100 dialog_body" fxLayoutGap="20px" fxLayout="column" fxLayoutAlign="start center">
            <div class="width_100 dialog_section" fxLayout="column" fxLayoutAlign="start center">
                <div class="width_100 section_header" style="margin-bottom: 20px;" fxLayoutGap="20px" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div class="width_80" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-icon [svgIcon]="'housekeeping'"></mat-icon>
                        <div class="section_header_label">Request Type</div>
                    </div>
                    <div class="section_quantity margin_right_15_px">Date & Time</div>
                </div>
                <div class="width_100 margin_bottom_20" fxLayoutGap="20px" fxLayout="column"
                    fxLayoutAlign="start center">
                    <div class="width_100 section_body" fxLayoutGap="20px" fxLayout="row"
                        fxLayoutAlign="space-between center">
                        <div class="section_body_label">Clean My Room</div>
                        <div class="section_body_quantity margin_right_15_px">
                            {{cleaningDateTime}}</div>
                    </div>
                </div>
                <!-- <div *ngIf="cleaningNote != '' && cleaningNote != null" class="width_100 margin_bottom_20"
                    fxLayoutGap="20px" fxLayout="column" fxLayoutAlign="start center">
                    <div class="width_100 section_body" fxLayoutGap="20px" fxLayout="row"
                        fxLayoutAlign="space-between center">
                        <div class="section_body_label"> <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                style="margin-right: 8px;" viewBox="0 0 12 12">
                                <path id="tag-outline"
                                    d="M14.646,8.748l-5.4-5.4A1.2,1.2,0,0,0,8.4,3H4.2A1.2,1.2,0,0,0,3,4.2V8.4a1.2,1.2,0,0,0,.354.852l5.4,5.4a1.2,1.2,0,0,0,1.692-.006l4.2-4.2a1.2,1.2,0,0,0,0-1.7M9.6,13.8,4.2,8.4V4.2H8.4l5.4,5.4M5.7,4.8a.9.9,0,1,1-.9.9A.9.9,0,0,1,5.7,4.8Z"
                                    transform="translate(-3 -3)" fill="gray" />
                            </svg>Note:</div>
                        <div class="section_body_quantity margin_right_15_px">
                            {{cleaningNote}}</div>
                    </div>
                </div> -->
            </div>
            <div *ngIf="cleaningNote != '' && cleaningNote != null" class="width_100 dialog_section" fxLayoutGap="20px"
                fxLayout="column" fxLayoutAlign="start center">
                <div class="width_100 section_header" fxLayoutGap="20px" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div class="width_100" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="start center">
                        <div class="section_header_label">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" style="margin-right: 8px;"
                                viewBox="0 0 12 12">
                                <path id="tag-outline"
                                    d="M14.646,8.748l-5.4-5.4A1.2,1.2,0,0,0,8.4,3H4.2A1.2,1.2,0,0,0,3,4.2V8.4a1.2,1.2,0,0,0,.354.852l5.4,5.4a1.2,1.2,0,0,0,1.692-.006l4.2-4.2a1.2,1.2,0,0,0,0-1.7M9.6,13.8,4.2,8.4V4.2H8.4l5.4,5.4M5.7,4.8a.9.9,0,1,1-.9.9A.9.9,0,0,1,5.7,4.8Z"
                                    transform="translate(-3 -3)" fill="gray" />
                            </svg>NOTE:
                        </div>
                    </div>
                </div>
                <div class="width_100 section_body" fxLayoutGap="20px" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div class="section_body_label">{{cleaningNote}}</div>
                </div>
            </div>
        </div>
        <div class="width_100 dialog_footer" fxLayout="row" fxLayoutAlign="center center">
            <div [mat-dialog-close]="requestStatus" fxLayout="row" class="request_status_new"
                fxLayoutAlign="center center">
                <div>Close</div>
            </div>
        </div>
    </div>
</div>